"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHead = void 0;
const clsx_1 = __importDefault(require("clsx"));
const atoms_1 = require("../../atoms");
const react_1 = __importDefault(require("react"));
function TableHead({ labels, className, testId, hideOnMobile = false, sticky = true, }) {
    return (react_1.default.createElement("thead", { className: (0, clsx_1.default)(hideOnMobile && 'hidden sm:table-header-group', className), "data-testid": testId },
        react_1.default.createElement("tr", null, labels.map((label, index) => (react_1.default.createElement("th", { key: `${label}-${index}`, scope: "col", className: (0, clsx_1.default)('py-3.5 pl-4 pr-3 sm:pl-0 bg-defaultBg', 'text-left', sticky && 'sticky z-8 top-0') },
            react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.SUBHEADING }, label)))))));
}
exports.TableHead = TableHead;
//# sourceMappingURL=TableHead.js.map